// Composition materials dropdown options
export const COMPOSITION_MATERIALS = ["Cotton", "Polyester", "Viscose", "Nylon", "Spandex", "Tencel", "Lyocell", "Linen"];

// Percentage options 1-100
export const PERCENTAGE_OPTIONS = Array.from({ length: 100 }, (_, i) => i + 1);

// Indian States
export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Delhi", "Jammu and Kashmir", "Ladakh", "Puducherry", "Chandigarh",
  "Andaman and Nicobar Islands", "Dadra and Nagar Haveli and Daman and Diu", "Lakshadweep"
];

// Major Indian cities for dropdown
export const INDIAN_CITIES = [
  "Ahmedabad", "Amritsar", "Bangalore", "Bhopal", "Bhubaneswar", "Chandigarh", 
  "Chennai", "Coimbatore", "Delhi", "Erode", "Faridabad", "Ghaziabad", "Gurgaon", 
  "Guwahati", "Hyderabad", "Ichalkaranji", "Indore", "Jaipur", "Jamnagar", "Jodhpur",
  "Kanpur", "Karur", "Kochi", "Kolkata", "Lucknow", "Ludhiana", "Madurai", "Mumbai", 
  "Nagpur", "Nashik", "Noida", "Panipat", "Patna", "Pune", "Raipur", "Rajkot", 
  "Ranchi", "Salem", "Surat", "Thane", "Tirupur", "Vadodara", "Varanasi", "Visakhapatnam",
  "Other"
];

// Bangladesh divisions (state equivalent)
export const BANGLADESH_DIVISIONS = [
  "Barishal", "Chattogram", "Dhaka", "Khulna", "Mymensingh",
  "Rajshahi", "Rangpur", "Sylhet"
];

// Major Bangladesh cities for dropdown
export const BANGLADESH_CITIES = [
  "Dhaka", "Chittagong", "Khulna", "Rajshahi", "Sylhet",
  "Rangpur", "Barishal", "Comilla", "Gazipur", "Narayanganj",
  "Mymensingh", "Bogra", "Cox's Bazar", "Jessore", "Dinajpur",
  "Savar", "Tongi", "Narsingdi", "Tangail", "Brahmanbaria",
  "Other"
];

// Denim OZ options from 2oz to 15oz in 0.25oz increments
export const DENIM_OZ_OPTIONS = Array.from({ length: 53 }, (_, i) => (2 + (i * 0.25)).toFixed(2).replace(/\.?0+$/, ''));

// Denier options for Denim and Polyester yarn count
export const DENIER_OPTIONS = [
  "20D", "30D", "40D", "50D", "70D", "75D", "100D", "150D", "200D", "250D", 
  "300D", "400D", "420D", "500D", "600D", "840D", "900D", "1000D", "1200D", "1680D"
];

// EPI/PPI options from 25 to 200
export const EPI_PPI_OPTIONS = Array.from({ length: 176 }, (_, i) => 25 + i);

// Pick Pool base required fields
export const PICK_POOL_BASE_REQUIRED = [
  'name', 'company_name', 'phone', 'email', 'gst_number', 'region', 'city',
  'fabric_type',
  'gsm', 'width_inches', 'quantity', 'quantity_unit',
  'material_1', 'sample_shared',
  'order_timeline'
];

// Fields required only for Dyed fabric type
export const PICK_POOL_DYED_REQUIRED = ['color'];

// Order Timeline options (mandatory for Pick Pool push)
export const ORDER_TIMELINE_OPTIONS = [
  "Within a week",
  "Within 15 days",
  "Within 30 days",
  "Just checking prices"
];
